<template>
  <div class="bg">
    <slot></slot>
  </div>
</template>

<style>
.bg {
  background: inherit;
  min-height: 100vh;
  padding: 25vh 0 1.5rem;
  transition: background 0s 1s, color 0.6s;
}

.bg:after {
  content: "";
  border: var(--border-width) solid;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 12;
  pointer-events: none;
  transition: 1s;
}

/* Adaptives */
@media only screen and (max-width: 64em) {
  .bg:after {
    display: none;
    visibility: hidden;
  }
}
@media only screen and (max-width: 30em) {
  .bg {
    padding: 15vh 0 1.5rem;
  }
}
/* End Adaptives */
</style>
